"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resetImageDimensions() {
    return (state, actions, { tabName = state.ui.currentTabName }) => () => {
        const originalContainerDimensions = state.tabs[tabName].originalContainerDimensions;
        const changes = {
            widthValue: '' + originalContainerDimensions.widthValue,
            widthFormat: originalContainerDimensions.widthFormat,
            heightValue: '' + originalContainerDimensions.heightValue,
            heightFormat: originalContainerDimensions.heightFormat,
        };
        actions.effects.changeContainerDimensions({
            tabName,
            dimensionType: 'active',
            changes: Object.assign({}, changes),
        });
    };
}
exports.resetImageDimensions = resetImageDimensions;
//# sourceMappingURL=reset-image-dimensions.js.map